{% block neti_incomplete_order_reminder_mail_log_list %}
    <sw-page
        class="swag-email-log-list"
        :isLoading="isLoading"
    >
        <template #smart-bar-header>
            <h2>
                {{ $t('neti-incomplete-order-reminder.mail-log.list.totalEntries') }}
                <span
                    v-if="!isLoading"
                    class="sw-page__smart-bar-amount"
                >
                    ({{ total }})
                </span>
            </h2>
        </template>

        <template #content>
            {% block neti_incomplete_order_reminder_mail_log_list_content %}
                <sw-entity-listing
                    v-if="mailLogEntries"
                    :items="mailLogEntries"
                    :repository="repository"
                    :showSelection="false"
                    :columns="columns"
                    :isLoading="isLoading"
                >
                    <template #column-mailed="{ item, compact }">
                        <mt-icon
                            v-if="item.mailed"
                            name="regular-checkmark-xs"
                            size="16px"
                            class="is--active"
                        />

                        <mt-icon
                            v-else
                            name="regular-times-s"
                            size="16px"
                            class="is--inactive"
                        />
                    </template>

                    <template #column-condition="{ item, compact }">
                        <div v-if="item.condition === 1">
                            {{ $t('neti-incomplete-order-reminder.condition.consent') }}
                        </div>

                        <div v-else-if="item.condition === 2">
                            {{ $t('neti-incomplete-order-reminder.condition.blackList') }}
                        </div>

                        <div v-else-if="item.condition === 4">
                            {{ $t('neti-incomplete-order-reminder.condition.orderSince') }}
                        </div>

                        <div v-else-if="item.condition === 5">
                            {{ $t('neti-incomplete-order-reminder.condition.reminded') }}
                        </div>

                        <div v-else-if="item.condition === 6">
                            {{ $t('neti-incomplete-order-reminder.condition.newsletter') }}
                        </div>

                        <div v-else-if="item.condition === 7">
                            {{ $t('neti-incomplete-order-reminder.condition.rule') }}
                        </div>

                        <div v-else>
                            {{ $t('neti-incomplete-order-reminder.condition.success') }}
                        </div>
                    </template>

                    <template #column-createdAt="{ item, compact }">
                        {{ dateFilter(item.createdAt, {hour: '2-digit', minute: '2-digit', second: '2-digit'}) }}
                    </template>

                    <template #column-email="{ item, compact }">
                       {{ item.email }}
                    </template>
                </sw-entity-listing>
            {% endblock %}
        </template>

        <template #sidebar>
            {% block incomplete_order_reminder_mail_log_side_bar %}
                <sw-sidebar>
                    <sw-sidebar-item
                        icon="regular-undo"
                        :title="$t('neti-incomplete-order-reminder.mail-log.list.refreshButton')"
                        @click="onRefresh"
                    >
                    </sw-sidebar-item>

                    <neti-ior-email-log-sidebar-filter @change="onFilterChanged"></neti-ior-email-log-sidebar-filter>

                    <mt-select></mt-select>
                </sw-sidebar>
            {% endblock %}
        </template>
    </sw-page>
{% endblock %}